"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRcodeInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactQrReader = require("react-qr-reader");
require("./styles.scss");
var _qrScannerDenied = _interopRequireDefault(require("./../assets/qr-scanner-denied.png"));
var _frame = _interopRequireDefault(require("./../assets/frame.svg"));
var _api = require("../api");
var _common = require("../../teacherDashboard/teacher/config/common");
var _QRcodePopup = _interopRequireDefault(require("./QRcodePopup"));
var _state = require("../state");
var _pushEventToGTM = require("../../commonHelpers/pushEventToGTM");
var _switchCamera = require("./switchCamera");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var LiveStream = null;
var shouldReload = true;
function isShortURL(inputString) {
  // Regular expression to match URLs  includes "slearn.me"
  var urlPattern = /^.*slearn\.me.*/;
  return urlPattern.test(inputString);
}
function isURL(inputString) {
  if (!inputString) return false;
  try {
    new URL(inputString); // If valid, it won't throw an error
    return true;
  } catch (_unused) {
    return false; // If invalid, it throws an error
  }
}
var QRcodeInput = exports.QRcodeInput = function QRcodeInput(_ref) {
  var _ref$setHasCameraAcce = _ref.setHasCameraAccess,
    setHasCameraAccess = _ref$setHasCameraAcce === void 0 ? function (val) {} : _ref$setHasCameraAcce;
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    showQRPopup = _useAuthSigninState.showQRPopup,
    setShowQRPopup = _useAuthSigninState.setShowQRPopup,
    getFromPage = _useAuthSigninState.getFromPage;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    result = _useState2[0],
    setResult = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    scannerError = _useState4[0],
    setScannerError = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoading = _useState8[0],
    setLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    success = _useState0[0],
    setSuccess = _useState0[1];
  var handleScan = function handleScan(data, err) {
    shouldReload = false;
    if (data) {
      setResult(data.text);
      if (data !== null && data !== void 0 && data.text) {
        setLoading(true);
        setSuccess(null);
        setError(null);
        setShowQRPopup(false);
        trackEventsForGuests("Class Login Attempted", _objectSpread({
          "mp_login_user_type": "student",
          "Login Method": "QR code"
        }, (data === null || data === void 0 ? void 0 : data.text) && isURL(data === null || data === void 0 ? void 0 : data.text) && {
          "Resolved URL": data === null || data === void 0 ? void 0 : data.text
        }), {
          send_mixpanel: true
        });
        if (isShortURL(data === null || data === void 0 ? void 0 : data.text)) {
          (0, _common.SetCookie)('qr_code_login_flow', "true", 1000 * 60 * 60 * 24 * 365);
          window.location.href = data === null || data === void 0 ? void 0 : data.text;
          return;
        }
        _api.APIS.qrCodeLogin(data === null || data === void 0 ? void 0 : data.text).then(function (res) {
          var _res$data;
          (0, _pushEventToGTM.pushEventToGTM)('logged_in', {
            user_type: 'student',
            label: 'qr code login'
          });
          setSuccess("Great job!");
          setTimeout(function () {
            return setLoading(false);
          }, 3000);
          window.location.href = "".concat(res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.redirect_to, "?loginMethod=QR code&fromPage=QR code scan input screen");
        })["catch"](function (e) {
          var _e$response;
          setError((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 ? void 0 : _e$response.error) || "Oops, try again!");
          setShowQRPopup(true);
        });
      }
    }
    if ((err === null || err === void 0 ? void 0 : err.name) === "NotAllowedError") {
      setScannerError(err);
    }
  };
  (0, _react.useEffect)(function () {
    onRequestCamera(true);
    return function () {
      if (LiveStream) {
        var _LiveStream;
        (_LiveStream = LiveStream) === null || _LiveStream === void 0 || (_LiveStream = _LiveStream.getTracks()) === null || _LiveStream === void 0 || _LiveStream.forEach(function (track) {
          track === null || track === void 0 || track.stop();
          track.enabled = false;
        });
      }
      if (shouldReload) {
        trackAnalyticsEvent('Viewed QR Code Screen Ignored Camera Access', {
          'Intent for': 'login',
          'Screen type': 'page',
          'From Page': 'signin'
        }, true);
        setTimeout(function () {
          return window.location.reload();
        }, 0);
      }
    };
  }, []);
  var onRequestCamera = function onRequestCamera(sendEvent, showAlert) {
    shouldReload = true;
    var constraints = {
      audio: false,
      video: {
        facingMode: _switchCamera.VideoFacingMode.environment
      }
    };
    setLoading(true);
    navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
      shouldReload = false;
      LiveStream = stream;
      setLoading(false);
      setScannerError(null);
      setHasCameraAccess(true);
      if (sendEvent) {
        trackEventsForGuests("Viewed QR Code Input Screen Camera Access", {
          "mp_login_user_type": "student",
          "From page": getFromPage() || "Direct URL entered"
        }, {
          send_mixpanel: true
        });
        (0, _pushEventToGTM.pushEventToGTM)('viewed_qr_code_screen_camera_access', {
          'Intent for': 'login',
          'Screen type': 'page',
          'From Page': 'signin'
        });
      }
    })["catch"](function (e) {
      shouldReload = false;
      setLoading(false);
      if (sendEvent) {
        trackEventsForGuests("Viewed QR Code Input Screen No Camera Access", {
          "mp_login_user_type": "student",
          "From page": getFromPage() || "Direct URL entered"
        }, {
          send_mixpanel: true
        });
        (0, _pushEventToGTM.pushEventToGTM)('viewed_qr_code_screen_no_camera_access', {
          'Intent for': 'login',
          'Screen type': 'page',
          'From Page': 'signin'
        });
      }
      setScannerError(e);
      setHasCameraAccess(false);
      if (showAlert) {
        setTimeout(function () {
          alert("Your camera access is blocked. You need to manually provide permission and reload page.");
        }, 0);
      }
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_switchCamera.SwitchCamera, {
    "data-sentry-element": "SwitchCamera",
    "data-sentry-component": "QRcodeInput",
    "data-sentry-source-file": "QRcodeInput.tsx"
  }, function (_ref2) {
    var switchCamera = _ref2.switchCamera,
      currentDeviceId = _ref2.currentDeviceId,
      deviceCount = _ref2.deviceCount,
      facingMode = _ref2.facingMode;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "qr-code-input"
    }, scannerError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "qr-scanner-denied"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _qrScannerDenied["default"]
    }), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", {
      className: "iconcust-iconWarning"
    }), /*#__PURE__*/_react["default"].createElement("label", null, "Allow camera access"))), isLoading && !scannerError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "qr-scanner-denied"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _qrScannerDenied["default"]
    }), shouldReload && /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", {
      className: "iconcust-iconWarning"
    }), /*#__PURE__*/_react["default"].createElement("label", null, "Allow camera access"))), !scannerError && !isLoading && /*#__PURE__*/_react["default"].createElement("div", null, currentDeviceId ? /*#__PURE__*/_react["default"].createElement(_reactQrReader.QrReader, {
      key: currentDeviceId,
      className: "qr-reader",
      scanDelay: 300,
      onResult: handleScan,
      constraints: {
        facingMode: facingMode,
        deviceId: currentDeviceId
      }
    }) : /*#__PURE__*/_react["default"].createElement(_reactQrReader.QrReader, {
      key: facingMode,
      className: "qr-reader",
      scanDelay: 300,
      onResult: handleScan,
      constraints: {
        facingMode: facingMode
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "frame ".concat(success ? "success" : "")
    }, /*#__PURE__*/_react["default"].createElement(_frame["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
      className: "scanner"
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "info"
    }, isLoading && !error && !success && result && /*#__PURE__*/_react["default"].createElement("div", {
      className: "loading"
    }, "Checking your QR code\u2026"), error && /*#__PURE__*/_react["default"].createElement("div", {
      className: "error"
    }, error), success && /*#__PURE__*/_react["default"].createElement("div", {
      className: "success"
    }, success)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "info-capture-msg"
    }, "The process of scanning the QR code does not capture any image, video, or other personal information. The process only reads the information contained in the QR code, which does not include any personal information."), scannerError && /*#__PURE__*/_react["default"].createElement("button", {
      onClick: function onClick() {
        onRequestCamera(true, true);
        trackEventsForGuests("Interacted QR code Input Screen No Camera Access", {
          "mp_login_user_type": "student",
          "Clicked on": "Allow camera access"
        }, {
          send_mixpanel: true
        });
      },
      className: "allow-camera-access"
    }, "Allow camera access"), !scannerError && deviceCount > 1 && /*#__PURE__*/_react["default"].createElement("button", {
      onClick: function onClick() {
        switchCamera();
        trackEventsForGuests("Interacted QR code Input Screen Camera Access", {
          "mp_login_user_type": "student",
          "Clicked on": "Switch Camera"
        }, {
          send_mixpanel: true
        });
      },
      className: "allow-camera-access"
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "iconcust-iconSync2"
    }), "Switch Camera"), showQRPopup ? /*#__PURE__*/_react["default"].createElement(_QRcodePopup["default"], {
      errorInfo: error,
      setLoading: setLoading,
      setError: setError
    }) : null);
  });
};